// 消息编号在浏览器生成，保存在当前草稿中，用于后端识别重复发送。
export const newMessageId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, item => item.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

// 增量页全部到齐才向界面提交，避免把尚未拉取的消息提前标记已读。
export const fetchMessageDelta = async (fetchPage, afterId, isActive = () => true) => {
  let cursor = afterId; const items = [];
  while (isActive()) {
    const result = await fetchPage({ after_id: cursor, pageSize: 50 });
    if (!Array.isArray(result?.data) || !result.pagination) throw new Error('消息响应无效');
    items.push(...result.data);
    const next = result.pagination.next_after_id;
    if (!result.pagination.has_more) return items;
    if (!Number.isSafeInteger(next) || next <= cursor) throw new Error('消息游标无效');
    cursor = next;
  }
  return [];
};
